import { render } from "./GuidesSecondaryTitle.vue?vue&type=template&id=ba6dd994"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "ba6dd994"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba6dd994', script)) {
    api.reload('ba6dd994', script)
  }
  
  module.hot.accept("./GuidesSecondaryTitle.vue?vue&type=template&id=ba6dd994", () => {
    api.rerender('ba6dd994', render)
  })

}

script.__file = "src/views/support/pageTitles/GuidesSecondaryTitle.vue"

export default script